var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"preview-slot"},[(!_vm.selectedTemplate)?_c('div',{staticClass:"alert alert-warning m-1 text-center"},[_c('strong',[_vm._v("Selecione um template no botão abaixo")])]):_c('div',{staticClass:"template-preview"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.selectedTemplate)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }